module.exports = __webpack_public_path__ + "static/img/ezekiel.2766585.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/ezekiel.jpg
// module id = +4pi
// module chunks = 1